import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { APP_CONFIG } from '../config';

interface Props {
  ctaType: 'valuation' | 'firstInInbox' | 'exclusiveListings' | 'opportunityCheck';
}

const kauerferPlusUrlParams = {
  valuation: { cmpCreative: 'valuation_cta', cmpId: '10-051672' },
  opportunityCheck: { cmpCreative: 'competition_analysis_cta', cmpId: '10-052294' },
  exclusiveListings: { cmpCreative: 'exclusive_listings_cta', cmpId: '10-052295' },
  firstInInbox: { cmpCreative: 'contact_at_top_cta', cmpId: '10-052296' },
};

const kaeuferPlusUrl = `${process.env.BASE_URL}/meinplus/vorteile/kaeuferplus`;

export const useGetDiscoverKaeuferPlusLink = ({ ctaType }: Props) => {
  const [searchParams] = useSearchParams();

  const { cmpCreative, cmpId } = React.useMemo(() => {
    return kauerferPlusUrlParams?.[ctaType] || { cmpCreative: null, cmpId: null };
  }, [ctaType]);

  const isMobileViewQueryParam =
    searchParams.get('headless') === 'true' || searchParams.get('isMobileView') === 'true' ? 'isMobileView=true&' : '';
  const returnUrl =
    ctaType === 'valuation' && !!APP_CONFIG.valuationWizardUrl ? APP_CONFIG.valuationWizardUrl : kaeuferPlusUrl;
  const encodedReturnUrl = encodeURIComponent(returnUrl);
  const queryParams = `cmp_id=${cmpId}&cmp_name=myscout_buying_buy&cmp_position=residential_benefits_buy&cmp_creative=${cmpCreative}`;
  return `${APP_CONFIG.checkoutUrl}?${isMobileViewQueryParam}returnUrl=${encodedReturnUrl}&${queryParams}`;
};
